module.exports = __webpack_public_path__ + "assets/img/00038.113346ae.png";